import React from "react";
import { useState } from "react";
import {Link as Lin} from "react-router-dom";
import { FaBars, FaTimes, FaGithub, FaLinkedin } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import { ImProfile } from "react-icons/im";
import { Fade } from "react-reveal";
import { Link } from "react-scroll";
import Logo from "../assets/logo.svg";

const Navbar = () => {
  const [nav, setNav] = useState(false);
  const handleClick = () => setNav(!nav);

  return (
    <div className="fixed w-full h-[80px] flex justify-between items-center px-4 bg-[#0B0F1F] text-gray-300 z-20">
      {/* Logo */}
      <div>
        <img src={Logo} alt="Logo" style={{ width: "150px" }} />
      </div>
      {/* Menu */}
      <ul className="hidden md:flex">
        <li className="m-1 relative group hover:text-slate-50">
          {window.location.pathname==="/"?<Link to="home" smooth={true} duration={500}>Home</Link>:<a href="/#" smooth={true} duration={500}>Home</a>}
          {/* <Link to="home" smooth={true} duration={500}>
            Home
          </Link> */}
          <span className="absolute -bottom-1 left-1/2 w-0 h-0.5 bg-[#CF6C2F] group-hover:w-1/3 group-hover:transition-all duration-300"></span>
          <span className="absolute -bottom-1 right-1/2 w-0 h-0.5 bg-[#CF6C2F] group-hover:w-1/3 group-hover:transition-all duration-300"></span>
        </li>
        <li className="m-1 relative group hover:text-slate-50">
          {window.location.pathname==="/"?<Link to="about" smooth={true} duration={500}>About</Link>:<a href="/" smooth={true} duration={500}>About</a>}
          {/* <Link to="about" smooth={true} duration={500}>
            About
          </Link> */}
          <span className="absolute -bottom-1 left-1/2 w-0 h-0.5 bg-[#CF6C2F] group-hover:w-1/3 group-hover:transition-all duration-300"></span>
          <span className="absolute -bottom-1 right-1/2 w-0 h-0.5 bg-[#CF6C2F] group-hover:w-1/3 group-hover:transition-all duration-300"></span>
        </li>
        <li className="m-1 relative group hover:text-slate-50">
          {window.location.pathname==="/"?<Link to="skills" smooth={true} duration={500}>Skills</Link>:<a href="/" smooth={true} duration={500}>Skills</a>}
          {/* <Link to="skills" smooth={true} duration={500}>
            Skills
          </Link> */}
          <span className="absolute -bottom-1 left-1/2 w-0 h-0.5 bg-[#CF6C2F] group-hover:w-1/3 group-hover:transition-all duration-300"></span>
          <span className="absolute -bottom-1 right-1/2 w-0 h-0.5 bg-[#CF6C2F] group-hover:w-1/3 group-hover:transition-all duration-300"></span>
        </li>
        <li className="m-1 relative group hover:text-slate-50">
          {window.location.pathname==="/"?<Link to="work" smooth={true} duration={500}>Work</Link>:<a href="/" smooth={true} duration={500}>Work</a>}
          {/* <Link to="work" smooth={true} duration={500}>
            Work
          </Link> */}
          <span className="absolute -bottom-1 left-1/2 w-0 h-0.5 bg-[#CF6C2F] group-hover:w-1/3 group-hover:transition-all duration-300"></span>
          <span className="absolute -bottom-1 right-1/2 w-0 h-0.5 bg-[#CF6C2F] group-hover:w-1/3 group-hover:transition-all duration-300"></span>
        </li>
        <li className="m-1 relative group hover:text-slate-50">
          <a href="/#/blogs">
            Blogs
          </a>
          <span className="absolute -bottom-1 left-1/2 w-0 h-0.5 bg-[#CF6C2F] group-hover:w-1/3 group-hover:transition-all duration-300"></span>
          <span className="absolute -bottom-1 right-1/2 w-0 h-0.5 bg-[#CF6C2F] group-hover:w-1/3 group-hover:transition-all duration-300"></span>
        </li>
        <li className="m-1 relative group hover:text-slate-50">
          {window.location.pathname==="/"?<Link to="contact" smooth={true} duration={500}>Contact</Link>:<a href="/" smooth={true} duration={500}>Contact</a>}
          {/* <Link to="contact" smooth={true} duration={500}>
            Contact
          </Link> */}
          <span className="absolute -bottom-1 left-1/2 w-0 h-0.5 bg-[#CF6C2F] group-hover:w-1/3 group-hover:transition-all duration-300"></span>
          <span className="absolute -bottom-1 right-1/2 w-0 h-0.5 bg-[#CF6C2F] group-hover:w-1/3 group-hover:transition-all duration-300"></span>
        </li>
      </ul>
      {/* Mobile Icon */}
      <div onClick={handleClick} className="md:hidden z-10 cursor-pointer">
        {!nav ? <FaBars size={20} /> : <FaTimes size={20} />}
      </div>
      {/* Mobile Menu */}
      <ul
        className={
          !nav
            ? "hidden"
            : "absolute top-0 left-0 w-full h-screen bg-[#0B0F1F] flex flex-col justify-center items-center "
        }
      >
        <Fade left cascade duration={500}>
          <li className="py-6 text-4xl">
            <Link onClick={handleClick} to="home" smooth={true} duration={500}>
              Home
            </Link>
          </li>
          <li className="py-6 text-4xl">
            <Link onClick={handleClick} to="about" smooth={true} duration={500}>
              About
            </Link>
          </li>
          <li className="py-6 text-4xl">
            <Link
              onClick={handleClick}
              to="skills"
              smooth={true}
              duration={500}
            >
              Skills
            </Link>
          </li>
          <li className="py-6 text-4xl">
            <Link onClick={handleClick} to="work" smooth={true} duration={500}>
              Work
            </Link>
          </li>
          <li className="py-6 text-4xl">
            <Lin onClick={handleClick} to="/#/blogs" smooth={true} duration={500}>
              Blogs
            </Lin>
          </li>
          <li className="py-6 text-4xl">
            <Link
              onClick={handleClick}
              to="contact"
              smooth={true}
              duration={500}
            >
              Contact
            </Link>
          </li>
        </Fade>
      </ul>
      {/* Social Icons */}
      <div className="hidden lg:flex fixed flex-col top-[35%] left-0">
        <ul>
          <li className="w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-[#0A66C2] rounded-md">
            <a
              className="flex justify-between items-center w-full text-gray-300 text-lg font-bold"
              href="https://www.linkedin.com/in/yathin-prakash-kethepalli/"
              target="_blank"
              rel="noreferrer"
            >
              LinkedIn
              <FaLinkedin size={30} />
            </a>
          </li>
          <li className="w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-[#2e2e2e] rounded-md">
            <a
              className="flex justify-between items-center w-full text-gray-300 text-lg font-bold"
              href="https://github.com/yathin017"
              target="_blank"
              rel="noreferrer"
            >
              Github
              <FaGithub size={30} />
            </a>
          </li>
          <li className="w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-[#379480] rounded-md">
            <a
              className="flex justify-between items-center w-full text-gray-300 text-lg font-bold"
              href="mailto:yathin20100@iiitnr.edu.in"
            >
              Email
              <HiOutlineMail size={30} />
            </a>
          </li>
          <li className="w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-[#565f69] rounded-md">
            <a
              className="flex justify-between items-center w-full text-gray-300 text-lg font-bold"
              href='./Yathin-Prakash-Kethepalli__CV.pdf'
              target="_blank"
              rel="noreferrer"
            >
              CV
              <ImProfile size={30} />
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Navbar;
